// Ortak arayüz metinleri. Sayfaya özgü uzun içerik, ilgili sayfa dosyasında { tr, en } olarak durur.

const STRINGS = {
  tr: {
    brand: 'Şogi Türkiye',
    brandTag: 'Japon Satrancı',
    nav: {
      play: 'Oyna',
      puzzles: 'Bulmacalar',
      arena: 'Arena',
      learn: 'Öğren',
      howto: 'Nasıl Oynanır?',
      pieces: 'Taşlar',
      rules: 'Kurallar',
      academy: 'Akademi',
      faq: 'SSS',
      leaderboard: 'Liderlik',
      apps: 'Uygulamalar',
      contact: 'İletişim',
      menu: 'Menü',
      playNow: 'Hemen Oyna',
      language: 'Dil',
    },
    auth: {
      loading: 'Yükleniyor…',
      login: 'Google ile Giriş',
      loggingIn: 'Giriş yapılıyor…',
      profile: 'Profilim ve Rozetlerim',
      logout: 'Çıkış Yap',
      streakDays: '{n} Gün',
      streakTitle: '{n} gün aralıksız giriş yapıldı!',
      player: 'Oyuncu',
      loginOk: 'Giriş başarılı!',
      loginFail: 'Giriş başarısız: {err}',
    },
    footer: {
      about: 'Japon satrancı şogiyi Türkçe öğrenmek, bilgisayara karşı oynamak, bulmaca çözmek ve online rakiplerle karşılaşmak için ücretsiz platform.',
      play: 'Oyna',
      learn: 'Öğren',
      community: 'Topluluk',
      blog: 'Blog',
      rights: 'Tüm hakları saklıdır.',
      getApps: 'Şogi her yerde',
    },
    store: {
      playBadgeSmall: "GOOGLE PLAY'DEN",
      playBadge: 'İndirin',
      chromeBadgeSmall: 'CHROME WEB MAĞAZASI',
      chromeBadge: 'Eklentiyi Ekle',
      appName: 'Japon Satrancı : Şogi',
      appDesc: "Android uygulamamızla şogiyi tam ekran, hızlı ve her yerde oynayın.",
      extName: 'Şogi Chrome Eklentisi',
      extDesc: 'Tarayıcınızın araç çubuğundan tek tıkla şogi oynayın.',
    },
    banner: {
      appTitle: 'Şogi uygulamamızı indirin',
      appText: "Japon Satrancı : Şogi — Google Play'de ücretsiz. Daha hızlı ve tam ekran oynayın.",
      appCta: 'Uygulamayı Yükle',
      extTitle: 'Chrome eklentimizi deneyin',
      extText: 'Şogi bir tık uzağınızda: araç çubuğundan hemen oyun açın.',
      extCta: "Chrome'a Ekle",
      later: 'Şimdi değil',
      close: 'Kapat',
    },
    level: {
      easy: 'Kolay',
      medium: 'Orta',
      hard: 'Zor',
      expert: 'Usta',
    },
    common: {
      sente: 'Sente',
      gote: 'Gote',
      senteLong: 'Sente (Siyah)',
      goteLong: 'Gote (Beyaz)',
      yes: 'Evet',
      no: 'Hayır',
      noHand: 'elde taş yok',
      loading: 'Yükleniyor…',
      moves: '{n} hamle',
      readMore: 'Devamı',
      play: 'Oyna',
      back: 'Geri',
    },
    move: {
      drop: '{p} elden {sq} karesine kondu',
      promoted: '(terfi etti)',
      captured: '— {p} alındı',
    },
    promote: {
      title: 'Terfi',
      text: 'Bu taşı terfi ettirmek ister misiniz?',
    },
  },
  en: {
    brand: 'Shogi Türkiye',
    brandTag: 'Japanese Chess',
    nav: {
      play: 'Play',
      puzzles: 'Puzzles',
      arena: 'Arena',
      learn: 'Learn',
      howto: 'How to Play',
      pieces: 'Pieces',
      rules: 'Rules',
      academy: 'Academy',
      faq: 'FAQ',
      leaderboard: 'Leaderboard',
      apps: 'Apps',
      contact: 'Contact',
      menu: 'Menu',
      playNow: 'Play Now',
      language: 'Language',
    },
    auth: {
      loading: 'Loading…',
      login: 'Sign in with Google',
      loggingIn: 'Signing in…',
      profile: 'My Profile & Badges',
      logout: 'Sign out',
      streakDays: '{n} days',
      streakTitle: 'Signed in {n} days in a row!',
      player: 'Player',
      loginOk: 'Signed in!',
      loginFail: 'Sign-in failed: {err}',
    },
    footer: {
      about: 'A free platform to learn shogi (Japanese chess), play against the computer, solve tsume puzzles and challenge players online.',
      play: 'Play',
      learn: 'Learn',
      community: 'Community',
      blog: 'Blog (Turkish)',
      rights: 'All rights reserved.',
      getApps: 'Shogi everywhere',
    },
    store: {
      playBadgeSmall: 'GET IT ON',
      playBadge: 'Google Play',
      chromeBadgeSmall: 'CHROME WEB STORE',
      chromeBadge: 'Add the extension',
      appName: 'Japanese Chess: Shogi',
      appDesc: 'Play shogi full-screen and on the go with our Android app.',
      extName: 'Shogi Chrome Extension',
      extDesc: 'Start a shogi game with one click from your browser toolbar.',
    },
    banner: {
      appTitle: 'Get our shogi app',
      appText: 'Japanese Chess: Shogi — free on Google Play. Faster, full-screen play.',
      appCta: 'Install the App',
      extTitle: 'Try our Chrome extension',
      extText: 'Shogi one click away: open a game right from your toolbar.',
      extCta: 'Add to Chrome',
      later: 'Not now',
      close: 'Close',
    },
    level: {
      easy: 'Easy',
      medium: 'Medium',
      hard: 'Hard',
      expert: 'Expert',
    },
    common: {
      sente: 'Sente',
      gote: 'Gote',
      senteLong: 'Sente (Black)',
      goteLong: 'Gote (White)',
      yes: 'Yes',
      no: 'No',
      noHand: 'no pieces in hand',
      loading: 'Loading…',
      moves: '{n} moves',
      readMore: 'Read more',
      play: 'Play',
      back: 'Back',
    },
    move: {
      drop: '{p} dropped on {sq}',
      promoted: '(promoted)',
      captured: '— captured {p}',
    },
    promote: {
      title: 'Promotion',
      text: 'Do you want to promote this piece?',
    },
  },
};

export default STRINGS;
